export const scrollToTopSelector = state => state.scroll.scrollToTop;
export const scrollToDirectorMessageSelector = state =>
	state.scroll.scrollToDirectorMessage;
export const scrollToInformationSelector = state => state.scroll.scrollToInformation;
export const scrollToProgramSelector = state => state.scroll.scrollToProgram;
export const scrollToDirectionSelector = state => state.scroll.scrollToDirection;
export const scrollToOpinionsSelector = state => state.scroll.scrollToOpinions;
export const scrollToContactSelector = state => state.scroll.scrollToContact;
